<template>
	<v-tab
		:active-class="activeClass"
		:disabled="disabled"
		:exact="exact"
		:href="href"
		:link="link"
		:ripple="ripple"
		:to="to"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot></slot>
	</v-tab>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		activeClass: String,
		disabled: Boolean,
		exact: Boolean,
		href: [String, Object],
		link: Boolean,
		ripple: [Boolean, Object],
		to: [String, Object]
	}
};
</script>
